import appConfig from 'app-config';
import { isIntegration } from 'flow/utils/is-integration';
import { getBrand } from 'flow/brands/brands';
import isElectron from 'is-electron';

export const FALLBACK_BRANDING_URL = 'joinflow.com';

export const getApiHost = () => {
    const windowLocation = window?.location;

    if (
        !appConfig.production ||
        (windowLocation && windowLocation.hostname.includes('localhost'))
    ) {
        return '';
    } else if (isIntegration()) {
        return 'https://cti.telavox.com';
    } else {
        if (isElectron()) {
            return appConfig.apiUrl;
        } else {
            return (
                getBrand()?.brandAdminUrl ||
                getApiHostFromLocation(windowLocation?.hostname) ||
                appConfig.apiUrl
            );
        }
    }
};

/**
 * Web fallback for when branding has not resolved: the registered domain of the page the
 * user is already on. Keeps a white-labelled deployment on its own domain instead of
 * exposing ours, and avoids appConfig.apiUrl, which on web is an Electron-only placeholder.
 */
export const getApiHostFromLocation = (hostname) => {
    const domain = hostname ? getDomainName(hostname) : null;
    return domain ? `https://${domain}` : null;
};

export const getDomainName = (hostname) => {
    /**
     * The goal is to get the top level domain (.com | .co.uk | .org)
     * and then grab the last part of the domain as well.
     * So if the url looks like this: my.very.verylong.testdomain.co.uk
     * then we identify ".co.uk", and add "testdomain", resulting in testdomain.co.uk.
     *
     * WARNING: We don't handle domains where
     * there are two top domain parts and the first part is more than 2 characters long.
     * Some relevant examples:
     *
     * Australia	(.com.au, .net.au, .gov.au, .org.au)
     * Saudi Arabia	(.com.sa, .edu.sa, .gov.sa, .org.sa)
     * Turkey	(.com.tr, .edu.tr, .gov.tr, .org.tr)
     */
    const domainRegexp =
        /^(?:.*?\.)?([a-zA-Z0-9\-_]{3,}\.(?:\w{2,8}|\w{2,2}\.\w{2,4}))$/;
    const regexpResult = domainRegexp.exec(hostname);

    if (!regexpResult) {
        return null;
    }

    return regexpResult[1];
};

export const getDomainPath = (hostname) => {
    if (!hostname) return null;
    const isLocalHost = hostname.includes('localhost');
    return !isLocalHost ? getDomainName(hostname) : FALLBACK_BRANDING_URL;
};

export const DEFAULT_BRANDING_URL = 'https://flow.telavox.com';
